import { ProviderShortNames } from "@modules/+new/payments/features/fiat-deposit/domain/entities/provider-short-names.enum";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { PaymentProviderDto } from "@modules/+new/payments/features/fiat-deposit/infrastructure/dto/payment-provider.dto";

export interface PaymentProvider {
	readonly shortName: ProviderShortNames;
}

export class PaymentProviderAdapter extends BaseAdapter<PaymentProviderDto, PaymentProvider> {
	public adapt(item: PaymentProviderDto): PaymentProvider {
		if (!item) {
			return null;
		}

		return {
			shortName: <ProviderShortNames>item.short_name
		};
	}
}
